import { Injectable } from '@angular/core';
import {Observable} from 'rxjs/Rx';

@Injectable()
export class ServicioGenerarObjetos{
	constructor (){}

	arregloAniosServicio(){
		var myDate = new Date();
		var year = myDate.getFullYear();
		let anios = [];
		for(var i = year; i < year+3; i++){
		  anios.push(i);
		}
		return anios;
	}
	arregloMesesServicio(){
		let meses = ["Enero","Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
		return meses;
	}
	arreglodiasMes(mes, anio){
		let dias = [];
		let diasEnElMes = 0;
		if(mes == "Febrero"){
			let noEsBisiesto=anio%400==0? false: anio%4 == 0 && anio%100!=0?false:true;
			if(noEsBisiesto){
				diasEnElMes =28;
			}else{
				diasEnElMes =29;
			}
		}else
		if(mes == "Abril" || mes == "Junio" || mes == "Septiembre" || mes == "Noviembre"){
			diasEnElMes = 30;
		}else if(mes== "Enero"|| mes== "Marzo"|| mes== "Mayo"|| mes== "Julio"|| mes== "Agosto"|| mes== "Octubre"|| mes== "Diciembre"){
			diasEnElMes = 31;
		}

		for (var i = 1; i < diasEnElMes; ++i) {
				dias.push(i);
			}
		return dias;
	}
	arreglohoras(){
		let anios = [];
		for(var i = 0; i < 24; i++){
		  anios.push(i);
		}
		return anios;
	}
	arreglominutos(){
		let minutos = [];
		for(var i = 0; i < 60; i =i+15){
		  minutos.push(i);
		}
		minutos.push(59);
		return minutos;
	}
}


// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/services/generar-objetos-select.service.ts